import React, { Component } from 'react';
import {
  Route,
  Switch,
  withRouter,
} from 'react-router-dom';
import { connect } from 'react-redux';
import GoToStart from './steps/goToStart';
import ColorSelection from './steps/colorSelection';
import AmountSelection from './steps/amountSelection';
import PrintSelection from './steps/printSelection';
import ReviewOrder from './steps/reviewOrder';

class Main extends Component {
  componentDidMount() {
    this.props.getGeneralTranslations();
  }

  render() {
    return (
      <Switch>
        <Route exact path="/" component={GoToStart} />
        <Route path="/colors/:id/" component={ColorSelection} />
        <Route path="/amount/" component={AmountSelection} />
        <Route path="/print/" component={PrintSelection} />
        <Route path="/revieworder/" component={ReviewOrder} />
      </Switch>
    );
  }
}

const mapDispatch = (dispatch) => {
  return {
    submitSelection: () => dispatch({
      type: 'SUBMIT_SELECTION',
    }),
    submitSizes: () => dispatch({
      type: 'SUBMIT_SIZES',
    }),
    getGeneralTranslations: () => dispatch({
      type: 'GET_GENERAL_TRANSLATIONS',
    }),
  };
};

export default withRouter(connect(null, mapDispatch)(Main));
